module.exports = __webpack_public_path__ + "img/book_04.5d66e0fe.jpg";